import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './CTA.css';

const CTA = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const handleContactClick = () => {
    window.location.href = '/contact';
  };

  return (
    <section className="cta" ref={ref}>
      <div className="cta-background">
        <img
          src="/assets/images/digital-globe.jpg"
          alt="Technology Background"
          className="background-image"
        />
        <div className="overlay"></div>
      </div>

      <div className="container">
        <motion.div
          className="cta-content"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <img src="/assets/images/Startup Streamline Core-Neon.svg" alt="" className="cta-icon" />
          <h2>{t('cta.title')}</h2>
          <p>{t('cta.subtitle')}</p>
          <motion.button
            className="cta-button"
            onClick={handleContactClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {t('cta.button')}
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;